module.exports = __webpack_public_path__ + "img/undraw_conference_call_b0w6.cfc7b3fc.svg";